<template>
  <div v-for="service in services">
    <h4 v-if="service.service_name">{{ service.service_name }}</h4>
    <p v-if="service.service_phone">{{ service.service_phone }}</p>
  </div>
</template>


<script>
export default {
  name: 'Services',

  props: {
    services: Object
  },
}
</script>
